import Input from '../../../components/input';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  createUserVirtualAccount,
  registerUser,
} from '../../../hooks/local/userReducer';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../components/spinner';
import { useState } from 'react';
import TermsOfService from './termsOfService';

const CreateAccount = () => {
  document.title = 'Create account - CloudVantage';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [termsModal, setTermsModal] = useState(false);

  const toggleTermsModal = () => {
    setTermsModal(!termsModal);
  };

  const createAcctForm = useFormik({
    initialValues: {
      fullname: '',
      emailadd: '',
      phonenumber: '',
      userpass: '',
      confirmPass: '',
      terms: false,
    },
    validationSchema: Yup.object({
      fullname: Yup.string().required('Please provide your full name'),
      emailadd: Yup.string()
        .required('Please provide your email address')
        .email('Please enter a valid email address'),
      phonenumber: Yup.string()
        .required('Phone Number cannot be empty')
        .typeError('Invalid Phone Number Format')
        .matches(
          /^[0-9]{9,11}$/,
          'Phone Number must be between 9 and 11 digits',
        ),
      userpass: Yup.string()
        .required('Password is required')
        .min(12, 'Password must be at least 12 characters long')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one digit')
        .matches(
          /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/,
          'Password must contain at least one special character',
        ),

      confirmPass: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('userpass'), null], 'Passwords must match'),

      terms: Yup.boolean()
        .oneOf([true], 'You must accept the Terms and Conditions')
        .required('You must accept the Terms and Conditions'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const { fullname, userpass, phonenumber, emailadd } = values;

      let virtualAccountData = {
        customerName: fullname,
        phoneNumber: phonenumber ? `1${phonenumber}` : null,
        mainPhoneNumber: '09069434255',
      };

      let registrationData;

      if (phonenumber) {
        // If phone number is provided, create virtual account

        const { payload: virtAcctPayload } = await dispatch(
          createUserVirtualAccount(virtualAccountData),
        );

        if (virtAcctPayload.status_code === '200') {
          const accountNumber = virtAcctPayload?.data?.accountNumber;
          const accountName = virtAcctPayload?.data?.accountName;

          registrationData = {
            fullname,
            userpass,
            phonenumber,
            emailadd,
            virt_acct_numb: accountNumber || '',
            virt_acct_name: accountName || '',
          };

          const { payload } = await dispatch(registerUser(registrationData));

          if (payload.statuscode === '00') {
            navigate('/');
            resetForm();
          }
        } else {
          // Fallback if virtual account creation fails
          registrationData = {
            fullname,
            userpass,
            phonenumber,
            emailadd,
          };

          const { payload } = await dispatch(registerUser(registrationData));

          if (payload.statuscode === '00') {
            navigate('/');
            resetForm();
          }
        }
      } else {
        registrationData = {
          fullname,
          userpass,
          // phonenumber: ,
          emailadd,
        };

        const { payload } = await dispatch(registerUser(registrationData));

        if (payload.statuscode === '00') {
          navigate('/');
          resetForm();
        }
      }
    },
  });

  // Check if required fields are filled
  const areRequiredFieldsFilled = () => {
    return (
      createAcctForm.values.fullname !== '' &&
      createAcctForm.values.emailadd !== '' &&
      createAcctForm.values.userpass !== '' &&
      createAcctForm.values.confirmPass !== '' &&
      !createAcctForm.errors.fullname &&
      !createAcctForm.errors.emailadd &&
      !createAcctForm.errors.userpass &&
      !createAcctForm.errors.confirmPass
    );
  };

  return (
    <div className="w-full">
      <Spinner loading={useSelector((state) => state.user).loading} />
      <div className="mb-8 text-center md:text-left">
        <h2 className="text-2xl font-bold dark:text-white mb-2">Create account</h2>
        <p className="text-gray-400 text-sm">Join CloudVantage and start your journey</p>
      </div>
      <form onSubmit={createAcctForm.handleSubmit} className="grid gap-6">
        <div className="grid gap-4">
          <p className="text-primaryBlue text-xs font-semibold uppercase tracking-wider">
            1. Personal information
          </p>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <Input
                    label={'Full name:'}
                    type={'text'}
                    name={'fullname'}
                    value={createAcctForm.values.fullname}
                    onChange={createAcctForm.handleChange}
                    onBlur={createAcctForm.handleBlur}
                    onError={
                      createAcctForm.touched.fullname &&
                      createAcctForm.errors.fullname
                        ? createAcctForm.errors.fullname
                        : null
                    }
                  />
                  <Input
                    label={'Email address:'}
                    type={'email'}
                    name={'emailadd'}
                    value={createAcctForm.values.emailadd}
                    onChange={createAcctForm.handleChange}
                    onBlur={createAcctForm.handleBlur}
                    onError={
                      createAcctForm.touched.emailadd &&
                      createAcctForm.errors.emailadd
                        ? createAcctForm.errors.emailadd
                        : null
                    }
                  />
                  <div className="lg:col-span-2">
                    <Input
                      label={'Phone number:'}
                      type={'tel'}
                      countryCodeDisplay={'true'}
                      placeholder={'e.g 0701 234 5678'}
                      name={'phonenumber'}
                      value={createAcctForm.values.phonenumber}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '');
                        createAcctForm.setFieldValue('phonenumber', val);
                      }}
                      onBlur={createAcctForm.handleBlur}
                      onError={
                        createAcctForm.touched.phonenumber &&
                        createAcctForm.errors.phonenumber
                          ? createAcctForm.errors.phonenumber
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/* Account security */}
        <div className="grid gap-4 mt-4">
          <p className="text-primaryBlue text-xs font-semibold uppercase tracking-wider">
            2. Account security
          </p>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <Input
                    label={'Password:'}
                    type={'password'}
                    isPassword={'true'}
                    placeholder={'*Required'}
                    name={'userpass'}
                    value={createAcctForm.values.userpass}
                    onChange={createAcctForm.handleChange}
                    onBlur={createAcctForm.handleBlur}
                    onError={
                      createAcctForm.touched.userpass &&
                      createAcctForm.errors.userpass
                        ? createAcctForm.errors.userpass
                        : null
                    }
                  />
                  <Input
                    label={'Confirm password:'}
                    type={'password'}
                    isPassword={'true'}
                    placeholder={'*Required'}
                    name={'confirmPass'}
                    value={createAcctForm.values.confirmPass}
                    onChange={createAcctForm.handleChange}
                    onBlur={createAcctForm.handleBlur}
                    onError={
                      createAcctForm.touched.confirmPass &&
                      createAcctForm.errors.confirmPass
                        ? createAcctForm.errors.confirmPass
                        : null
                    }
                  />
                </div>
              </div>
              {/* Password verification */}
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-2">
          <p className="mb-2 font-medium">Your password must contain:</p>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-1">
            <li className="flex items-center gap-1">at least 12 characters</li>
            <li className="flex items-center gap-1">at least 1 special character</li>
            <li className="flex items-center gap-1">at least 1 number</li>
            <li className="flex items-center gap-1">at least 1 uppercase</li>
          </ul>
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400 mt-4 grid gap-3">
          <p>
            To create an account, you must agree to our{' '}
            <span
              className="text-primaryBlue cursor-pointer font-medium hover:underline"
              onClick={toggleTermsModal}
            >
              Terms and Conditions
            </span>.
          </p>
          <div className="flex items-start gap-2">
            <input
              type="checkbox"
              id="terms"
              name="terms"
              disabled={!areRequiredFieldsFilled()}
              checked={createAcctForm.values.terms}
              onChange={(e) => {
                createAcctForm.setFieldValue('terms', e.target.checked);
                createAcctForm.setFieldTouched('terms', true);
              }}
              className="mt-1 rounded border-gray-300 text-primaryBlue focus:ring-primaryBlue"
            />
            <label
              htmlFor="terms"
              className={`text-[13px] ${
                !areRequiredFieldsFilled()
                  ? 'text-gray-400'
                  : 'text-gray-600 dark:text-gray-300'
              }`}
            >
              I agree to the Terms and Conditions
            </label>
          </div>
          {createAcctForm.touched.terms &&
            !createAcctForm.values.terms &&
            createAcctForm.errors.terms && (
              <span className="text-red-500 text-xs">
                {createAcctForm.errors.terms}
              </span>
            )}
        </div>
        <div className="mt-6 flex flex-col gap-4">
          <button
            type="submit"
            className="w-full bg-primaryBlue text-white py-4 text-lg font-semibold rounded-lg shadow-lg shadow-blue-200 dark:shadow-none transition-transform active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Create account
          </button>
          <p className="text-center text-sm text-gray-500 dark:text-gray-400">
            Already have an account?{' '}
            <Link
              to={'/'}
              className="text-primaryBlue font-semibold hover:underline"
            >
              Sign in
            </Link>
          </p>
        </div>
      </form>
      {termsModal && (
        <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
          <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[40%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto p-4 border-y-[16px] dark:border-y-[#141d26]">
            <div
              className="cursor-pointer text-right text-[#c4c4c4]"
              onClick={toggleTermsModal}
            >
              [Close]
            </div>
            <TermsOfService />
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateAccount;
